import { useState } from 'react'

import { useShipmentFileFeed } from '#/entities/shipment'
import type { ShipmentFileFeedItem } from '#/entities/shipment'
import type { useCreateToolbarItem } from '#/features/shipment-toolbar'

export function useOrderFiles(
  shipmentId: string | undefined,
  armed: boolean,
): { files: ShipmentFileFeedItem[]; isLoading: boolean } {
  const { files, isLoading } = useShipmentFileFeed(shipmentId ?? '', {
    enabled: armed && Boolean(shipmentId),
    isOrderFile: true,
  })
  return { files, isLoading }
}

interface FileSliceDeps {
  shipmentId: string | undefined
  uploadFile: ReturnType<typeof useCreateToolbarItem>['uploadFile']
  isUploading: boolean
  closeTab: () => void
}

export function useFileSlice({
  shipmentId,
  uploadFile,
  isUploading,
  closeTab,
}: FileSliceDeps) {
  const [selection, setSelection] = useState<File | null>(null)

  const onPick = (list: FileList) => {
    const next = list.item(0)
    if (next) setSelection(next)
  }

  const onClear = () => setSelection(null)

  const onCancel = () => {
    setSelection(null)
    closeTab()
  }

  const onSave = async (displayName?: string) => {
    if (!shipmentId || !selection || isUploading) return
    try {
      await uploadFile({ file: selection, displayName })
      setSelection(null)
      closeTab()
    } catch {
      void 0
    }
  }

  return {
    selection,
    onPick,
    onClear,
    onCancel,
    onSave,
    isUploading,
    canSave: Boolean(shipmentId && selection && !isUploading),
  }
}
